{
  "appName": "Income Limits",
  "entryFile": "./income-limits-entry.jsx",
  "entryName": "income-limits",
  "rootUrl": "/health-care/income-limits"
}
